
















































































































































































































































































import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'

import FilterCategory from '@/search/components/FilterCategory.vue'
import FilterPrintMethod from '@/search/components/FilterPrintMethod.vue'
import FilterUnitPrice from '@/search/components/FilterUnitPrice.vue'
import FilterFacets from '@/search/components/FilterFacets.vue'
import FilterIndustry from '@/search/components/FilterIndustry.vue'
import Pagination from '@/common/components/Pagination.vue'
import SearchMetaHeader from '@/search/components/SearchMetaHeader.vue'
import SearchMeta from '@/search/components/SearchMeta.vue'
import BrandInfo from '@/search/components/brand/BrandInfo.vue'
import SubCategories from '@/search/components/SubCategories.vue'
import Loading from '@/common/components/Loading.vue'
import PrioritizedFilter from '@/search/components/prioritizedFilters/PrioritizedFilter.vue'
import LibraryImage from '@/search/components/LibraryImage.vue'
import FilterEditPatterns from '@/search/components/FilterEditPatterns.vue'
import CategoryMarkdownContent from '@/search/components/CategoryMarkdownContent.vue'
import RelatedLinks from '@/common/components/RelatedLinks.vue'
import Announcements from '@/common/components/announcements/Announcements.vue'
import ParamModal from '@/search/components/ParamModal.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import ProductList from '@/common/components/ProductList.vue'
import MagazineCarousel from '@/common/components/magazine/MagazineCarousel.vue'
import ListTagsMobile from '@/search/components/ListTagsMobile.vue'
import BrandHeader from '@/search/components/brand/BrandHeader.vue'
import FAQ from '@/common/components/faq/FAQ.vue'

import {
  ProductCards,
  PrintingMethodsCount,
  SearchParamModel,
  SearchFacets,
  SearchFacetValues,
  IndustryValue,
  FacetValuesType,
  VIEW_MODES,
  EditPattern,
  BrandCategory,
  BrandValue
} from '@/search/types'
import { getAllSearchProducts, getPriceRange } from '@/search/services'
import { BrandModel } from '@/common/types/brands'
import {
  NUMBER_ITEM_PER_PAGE,
  MAX_DISPLAY_PAGE_NUMBER,
  DEFAULT_SORT_ORDER,
  FACET_INDIVIDUAL,
  FACET_QUERY_PREFIX,
  ROUTE_NAMES,
  SORT_ORDER,
  BRAND_FACET_KEY_NAME,
  GENDER_FACET_KEY_NAME,
  COLOR_FACET_KEY_NAME,
  SEO_CATEGORIES
} from '@/search/const'
import cloneDeep from 'lodash/cloneDeep'
import omitBy from 'lodash/omitBy'
import omit from 'lodash/omit'
import isEmpty from 'lodash/isEmpty'
import orderBy from 'lodash/orderBy'
import eventBus from '@/common/utils/eventBus'
import { APP_EVENTS, SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES} from '@/common/constants'
import { getJsonData } from '@/common/utils/dom'
import { data } from '@/search/const/selectors'
import { MutationTypes, State } from '@/search/store'
import {
  BQ_EVENT_NAMES,
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  EVENT_LABELS,
  gaEventTracker,
  raksulBQEventTracker,
  SEARCH_TRACKING_QUERY
} from '@/common/utils/eventTracker'
import { MAGAZINE_TYPES } from '@/magazine/consts'
import { getCMSLinks } from '@/common/service'
import { CmsMappingTypeEnum } from '@/types/graphqlQuery'
import { getSearchPageQueryObject } from '@/common/utils/common'
import { DisplayChildCategory, RelatedLink } from '@/common/types/index'
import { Faq } from '@/types/common'
import { faqs } from '@/common/data/faqs'
import union from 'lodash/union'

const productCategories = getJsonData('#applicationData').productCategories
const initPageCategoryId = getJsonData(data.categoryEl).id
const initPageIndustryId = getJsonData(data.industryEl).id
const industryList = getJsonData(data.industriesEl)
const brandList = getJsonData(data.brandsEl)
const initPageBrand = getJsonData(data.brandEl) as BrandValue

export default Vue.extend({
  name: 'SearchPage',
  components: {
    FilterCategory,
    FilterPrintMethod,
    FilterUnitPrice,
    FilterFacets,
    SearchMetaHeader,
    SearchMeta,
    Loading,
    Pagination,
    FilterIndustry,
    BrandInfo,
    SubCategories,
    PrioritizedFilter,
    LibraryImage,
    RelatedLinks,
    CategoryMarkdownContent,
    ProductList,
    FilterEditPatterns,
    MagazineCarousel,
    Announcements,
    ParamModal,
    BaseImage,
    ListTagsMobile,
    BrandHeader,
    FAQ
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.name === ROUTE_NAMES.CHILD_CATEGORY && from.name === ROUTE_NAMES.BRAND) {
        // @ts-ignore
        vm.buildBreadcrumb(to.params.childCategory, from.name)
      }
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === ROUTE_NAMES.CHILD_CATEGORY && from.name === ROUTE_NAMES.CHILD_CATEGORY) {
        this.buildBreadcrumb(to.params.childCategory, from.name)
      }
    next()
  },
  props: {
    pageCategoryId: {
      type: String,
      default: undefined
    },
    pageIndustryId: {
      type: [String, Number],
      default: undefined
    }
  },
  data(): {
    searchParams: SearchParamModel
    selectedPage: number
    itemTotalCount: number
    categoryLabel: string
    productCards: ProductCards[] | []
    printingMethodsCount: {
      [key: string]: PrintingMethodsCount
    }
    allSearchFacets: SearchFacets[]
    loadingState: boolean
    isLoadingDone: boolean
    categorySearchCount: []
    industries: IndustryValue[]
    brands: BrandModel[]
    initFacetKeyCondition:
      | {
          facetKey: string
          facetValues: string[]
        }[]
      | null
    productCategories: Array<ProductCategory>
    sortedProductCategories: Array<ProductCategory>
    breadcrumbElm: Element
    shouldTrackingSearchKeyword: boolean
    designImage?: string
    editPatternList: EditPattern[]
    cmsLinks: RelatedLink[]
    cmsMagazines: []
    paramModalVisible: boolean
    brandCategories: BrandCategory[]
  } {
    return {
      searchParams: {
        minUnitPrice: 0,
        maxUnitPrice: 0,
        categoryId: null,
        printingMethods: [],
        facetValueNames: [],
        offset: 0,
        limit: NUMBER_ITEM_PER_PAGE,
        sortOrder: DEFAULT_SORT_ORDER,
        industryIds: [],
        brandIds: [],
        keyword: '',
        userDesignVersionUuid: '',
        editPatterns: []
      },
      selectedPage: 1,
      itemTotalCount: 0,
      categoryLabel: '',
      productCards: [],
      allSearchFacets: [],
      printingMethodsCount: {},
      loadingState: false,
      isLoadingDone: false,
      categorySearchCount: [],
      industries: industryList,
      brands: brandList || [],
      initFacetKeyCondition: [],
      productCategories: productCategories,
      sortedProductCategories: cloneDeep(productCategories),
      breadcrumbElm: document.getElementsByClassName('ui-breadcrumb')[0],
      shouldTrackingSearchKeyword: false,
      designImage: undefined,
      editPatternList: [],
      cmsLinks: [],
      cmsMagazines: [],
      paramModalVisible: false,
      brandCategories: []
    }
  },
  computed: {
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    viewMode(): number {
      switch (this.$route.name) {
        case ROUTE_NAMES.CATEGORY:
        case ROUTE_NAMES.CHILD_CATEGORY:
          return VIEW_MODES.SEARCH_CATEGORIES
        case ROUTE_NAMES.BRAND:
          return VIEW_MODES.SEARCH_BRANDS
        default:
          return VIEW_MODES.SEARCH
      }
    },
    isMobileView(): boolean {
      return window.innerWidth < 1024
    },
    isBrandView(): boolean {
      return this.viewMode === VIEW_MODES.SEARCH_BRANDS
    },
    isCategoryView(): boolean {
      return this.viewMode === VIEW_MODES.SEARCH_CATEGORIES
    },
    isSearchView(): boolean {
      return this.viewMode === VIEW_MODES.SEARCH
    },
    isCategoryUnderBrandView(): boolean {
      return !!(this.isCategoryView && this.routeQuery.f_brand)
    },
    searchMetaVisible(): boolean {
      return this.viewMode === VIEW_MODES.SEARCH
    },
    squareImgPlaceholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    openIndustryFilter(): boolean {
      return this.$store.state.openIndustryFilter
    },
    openBrandFilter(): boolean {
      return this.$store.state.openBrandFilter && !this.isMobileView
    },
    openCategoryFilter(): boolean {
      return this.$store.state.openCategoryFilter
    },
    prioritizedSearchFacets(): SearchFacets[] {
      return this.allSearchFacets.filter(
        item =>
          item.facetKeyName === GENDER_FACET_KEY_NAME ||
          item.facetKeyName === COLOR_FACET_KEY_NAME
      )
    },
    brandSearchFacet(): SearchFacets[] {
      return this.allSearchFacets.filter(
        item =>
          item.facetKeyName === BRAND_FACET_KEY_NAME
      )
    },
    initBrandId(): number {
      return Number(initPageBrand.id)
    },
    otherSearchFacets(): SearchFacets[] {
      return this.allSearchFacets.filter(
        item =>
          item.facetKeyName !== GENDER_FACET_KEY_NAME &&
          item.facetKeyName !== COLOR_FACET_KEY_NAME &&
          item.facetKeyName !== BRAND_FACET_KEY_NAME
      )
    },
    setFacetsTag(): Array<{ [key: string]: string }> {
      let objItems: Array<{ [key: string]: string }> = []
      this.allSearchFacets.forEach((entry1: SearchFacets) => {
        entry1.facetValues.forEach((entry2: SearchFacetValues) => {
          if (
            this.searchParams.facetValueNames &&
            this.searchParams.facetValueNames.includes(entry2.facetValueName)
          ) {
            const objectItems = {
              valueKey: '',
              valueName: '',
              facetKey: '',
              facetName: ''
            }
            objectItems.valueKey = entry2.facetValueName
            objectItems.valueName = entry2.facetValueDisplayName
            objectItems.facetKey = entry1.facetKeyName
            objectItems.facetName = entry1.facetKeyDisplayName
            objItems.push(objectItems)
          }
        })
      })
      return objItems
    },
    formatFacets(): Array<FacetValuesType> {
      return Array.from(new Set(this.setFacetsTag.map(s => s.facetKey))).map(
        facet => {
          return {
            facetKey: facet as string,
            facetValues: this.setFacetsTag
              .filter(s => s.facetKey === facet)
              .map(edition => edition.valueKey)
          }
        }
      )
    },
    setFacetUrl(): any {
      const arrayKey: { [key: string]: string } = {}
      this.allSearchFacets.forEach((item1: SearchFacets) => {
        const arrayValues: string[] = []
        item1.facetValues.forEach((item2: SearchFacetValues) => {
          if (
            this.searchParams.facetValueNames.includes(item2.facetValueName)
          ) {
            arrayValues.push(item2.facetValueName)
          }
          arrayKey[item1.facetKeyName] = arrayValues?.toString()
        })
      })
      return arrayKey
    },
    routeQuery(): { [key: string]: string } {
      return this.$route.query as { [key: string]: string }
    },
    currentIndexItems(): number {
      return this.selectedPage < 2
        ? 1
        : NUMBER_ITEM_PER_PAGE * this.selectedPage - NUMBER_ITEM_PER_PAGE + 1
    },
    totalIndexItems(): number {
      const totalIndexItem = NUMBER_ITEM_PER_PAGE * this.selectedPage
      return totalIndexItem < this.itemTotalCount
        ? totalIndexItem
        : this.itemTotalCount
    },
    setIndustryTag(): IndustryValue[] {
      const results = this.searchParams.industryIds.map(id => {
        return this.industries.find(i => i.id == id)!
      })
      return results
    },
    setCategoryTag(): string {
      const result = {}
      this.productCategories.forEach(item =>
        this.getValueByKeys(item, 'shortDisplayName', result)
      )
      let categoryName = result[this.searchParams.categoryId]
      return categoryName ?? ''
    },
    categoryViewTag(): string {
      return this.isCategoryUnderBrandView
        ? this.firstSelectedBrandName + 'の' + this.setCategoryTag
        : this.setCategoryTag
    },
    tagEditPatterns(): {value: string, label: string }[] {
      return this.searchParams.editPatterns?.map(item => {
        const editPattern = this.editPatternList.find(pattern => pattern.editPatternName === item)
        return {
          value: editPattern?.editPatternName || '',
          label: editPattern?.editPatternDisplayName || ''
        }
      }) || []
    },
    setCategoryCount(): { [key: string]: number } {
      const result = {}
      this.categorySearchCount.forEach((entry1: any) => {
        this.getValueByKeys(entry1, 'topSearchCount', result)
      })
      return result
    },
    selectedIndustryTag(): string {
      return this.industries.find(
        item => item.id === this.searchParams.industryIds[0]
      )?.displayName ?? ''
    },
    selectedCategory(): ProductCategory | undefined {
      const searchCategoryId = this.searchParams.categoryId
        ? parseInt(this.searchParams.categoryId)
        : undefined

      for (const cat of this.productCategories) {
        if (cat.id === searchCategoryId) return cat
        const childCat = cat.childCategories.find(childCarItem => childCarItem.id === searchCategoryId)
        if (childCat) return childCat
      }
      return undefined
    },
    selectedCategoryDescription(): string {
      return this.selectedCategory?.description || ''
    },
    selectedCategoryThumbnail(): string {
      return this.selectedCategory?.iconImageUrl || ''
    },
    selectedCategoryMarkdownContent(): string {
      return this.selectedCategory?.detail || ''
    },
    displayedChildCategories(): DisplayChildCategory[] {
      return this.selectedCategory
        ? this.selectedCategory.childCategories.map(item => ({
          id: item.id.toString(),
          displayName: item.displayName,
          thumbnail: item.iconImageUrl,
          alt: item.iconImageAlt,
          url: item.url
        }))
        : []
    },
    setUnitPriceTag(): string {
      return this.searchParams.minUnitPrice > 1 ||
        this.maxThreshold > this.searchParams.maxUnitPrice
        ? `単価：${this.searchParams.minUnitPrice} ~ ${this.searchParams.maxUnitPrice}`
        : ''
    },
    setPrintingMethod(): any {
      return {
        label: '印刷方法',
        items: this.searchParams.printingMethods
      }
    },
    paginationOptions(): {
      maxNumberOfDisplayPages: number
      numberOfItemsPerPage: number
      showPagination: boolean
      totalItems: number
    } {
      return {
        numberOfItemsPerPage: this.searchParams.limit,
        maxNumberOfDisplayPages: MAX_DISPLAY_PAGE_NUMBER,
        showPagination: this.itemTotalCount > this.searchParams.limit,
        totalItems: this.itemTotalCount
      }
    },
    hasSearchCondition(): boolean {
      return (this.searchParams.minUnitPrice && this.searchParams.minUnitPrice !== this.minThreshold)
        || (this.searchParams.maxUnitPrice && this.searchParams.maxUnitPrice !== this.maxThreshold)
        || (this.searchParams.printingMethods && this.searchParams.printingMethods.length > 0 )
        || ( this.searchParams.facetValueNames && this.searchParams.facetValueNames.length > 0)
        || !!this.searchParams.userDesignVersionUuid
    },
    hasIndustry(): boolean {
      return this.searchParams.industryIds && this.searchParams.industryIds.length > 0
    },
    hasSearchConditionOrIndustry(): boolean {
      return this.hasSearchCondition || this.hasIndustry
    },
    minThreshold(): number {
      return (this.$store.state as State).minThreshold
    },
    maxThreshold(): number {
      return (this.$store.state as State).maxThreshold
    },
    cmsMappableIds(): string[] {
      switch (this.viewMode) {
        case VIEW_MODES.SEARCH_INDUSTRIES:
          return [this.searchParams.industryIds[0]?.toString()]
        case VIEW_MODES.SEARCH_CATEGORIES:
          return [this.searchParams.categoryId?.toString() || '']
        case VIEW_MODES.SEARCH_BRANDS:
          return [this.initBrandId?.toString()]
        default:
          return []
      }
    },
    cmsMappableType(): string {
      switch (this.viewMode) {
        case VIEW_MODES.SEARCH_INDUSTRIES:
          return CmsMappingTypeEnum.Industry
        case VIEW_MODES.SEARCH_CATEGORIES:
          return CmsMappingTypeEnum.Category
        case VIEW_MODES.SEARCH_BRANDS:
          return CmsMappingTypeEnum.Brand
        default:
          return ''
      }
    },
    productExtendQueries(): {[key: string]: string} {
      return this.searchParams.userDesignVersionUuid ? { designVersion: this.searchParams.userDesignVersionUuid }
        : {}
    },
    magazineTypes(): {[key: string]: string} {
      return MAGAZINE_TYPES
    },
    firstSelectedBrandName(): string {
      return this.brandSearchFacet.length ? this.brandSearchFacet[0].facetValues[0].facetValueDisplayName : ''
    },
    currentCategoryId(): number | undefined {
      return this.searchParams.categoryId
        ? parseInt(this.searchParams.categoryId)
        : undefined
    },
    siblingCategoryLinks(): RelatedLink[] {
      if (!this.currentCategoryId) return []
      const currentCategory = this.productCategories.find(cat => {
        if (!cat.childCategories) return false
        return cat.childCategories.find(childCat =>
          childCat.id === this.currentCategoryId
        )
      })

      const siblingCategories = currentCategory?.childCategories.filter(item => item.id !== this.currentCategoryId).map(item => ({
        name: item.displayName,
        url: item.url
      })) || []

      return siblingCategories
    },
    seoCategories(): RelatedLink[] {
      if (!this.currentCategoryId) return []

      const mainSeoCategory = SEO_CATEGORIES.find(cat => cat.mainCategory === this.currentCategoryId)
      const subSeoCategories = SEO_CATEGORIES.find(cat => cat.subCategories.includes(this.currentCategoryId!))?.subCategories
      const seoCategoryIds = (mainSeoCategory ? mainSeoCategory.subCategories : subSeoCategories || []).filter(id => id !== this.currentCategoryId)

      return this.productCategories.reduce((acc, cat) => {
        return acc.concat(cat.childCategories.filter(childCat => seoCategoryIds.includes(childCat.id)).map(childCat => ({
          name: childCat.displayName,
          url: childCat.url
        })))
      }, [] as RelatedLink[])
    },
    relatedCategoryLinks(): RelatedLink[] {
      return union(this.siblingCategoryLinks, this.seoCategories)
    },
    faqs(): Faq[] {
      return faqs
    },
    pathName(): string {
      return this.isCategoryUnderBrandView
        ? `${window.location.pathname}?f_brand=${this.routeQuery.f_brand}`
        : window.location.pathname
    }
  },
  watch: {
    setCategoryTag(value: string) {
      if (this.isSearchView)
        document.title = 'すべてのカテゴリー｜ラクスル アパレル・ユニフォーム'
      else if (!this.isCategoryUnderBrandView)
        document.title = value + '通販｜ラクスル'
    },
    selectedIndustryTag(value: string) {
      if (this.isSearchView)
        document.title = 'すべてのカテゴリー｜ラクスル アパレル・ユニフォーム'
      else
        document.title = value + '｜ラクスル アパレル・ユニフォーム'
    },
    'searchParams.keyword'(value: string) {
      if (value)
        document.title = `「${value}」の検索結果｜ラクスル`
      else
        document.title = 'すべてのカテゴリー｜ラクスル アパレル・ユニフォーム'
    },
    viewMode: {
      immediate: true,
      handler(value) {
        if (value === VIEW_MODES.SEARCH_BRANDS) {
          if (isNaN(initPageBrand.id)) {
            const label = `Brand fetch _ ${initPageBrand.id}`
            return gaEventTracker(EVENT_CATEGORIES.SEARCH, EVENT_ACTIONS.LOG, label)
          }
        }
        if (this.breadcrumbElm) {
          const visibility =
            value === VIEW_MODES.SEARCH_CATEGORIES || value === VIEW_MODES.SEARCH_BRANDS
              ? 'flex'
              : 'none'
          this.breadcrumbElm.style.display = visibility
        }
      }
    }
  },
  created() {
    if (!this.maxThreshold) {
      getPriceRange().then(priceRange => {
        this.$store.commit(MutationTypes.SET_PRICE_RANGE, {
          minThreshold: priceRange.minPrice,
          maxThreshold: priceRange.maxPrice
        })
      })
    }
    this.searchParams.minUnitPrice = this.routeQuery?.min && !isNaN(Number(this.routeQuery?.min)) ? Number(this.routeQuery?.min) : undefined
    this.searchParams.maxUnitPrice = this.routeQuery?.max && !isNaN(Number(this.routeQuery?.max)) ? Number(this.routeQuery?.max) : undefined
    this.searchParams.printingMethods = this.routeQuery?.printing ? this.routeQuery.printing.split(',') : []
    this.searchParams.categoryId = this.initCategoryId()
    this.searchParams.sortOrder = this.getSortInitValue(this.routeQuery?.sortorder)
    this.searchParams.userDesignVersionUuid = this.routeQuery?.designVersion
    this.searchParams.editPatterns = this.routeQuery?.editPatterns?.split(',') || []
    const initIndustryIds = this.initIndustryIds()
    this.searchParams.industryIds = initIndustryIds
      ? initIndustryIds.split(',')?.map(item => Number(item))
      : []
    if (this.routeQuery) {
      const facets = Object.keys(this.routeQuery).filter(key =>
        key.startsWith(FACET_QUERY_PREFIX)
      )
      this.initFacetKeyCondition = facets.map(key => {
        return {
          facetKey: key.replace(FACET_QUERY_PREFIX, ''),
          facetValues: this.routeQuery[key].split(',')
        }
      })
      const facetVals: string[] = []
      this.initFacetKeyCondition.forEach(item => {
        facetVals.push(...item.facetValues)
      })
      if (this.$route.name === ROUTE_NAMES.BRAND) {
        this.initFacetKeyCondition.push({
          facetKey: BRAND_FACET_KEY_NAME,
          facetValues: [this.$route.params.brandName]
        })
        facetVals.push(this.$route.params.brandName)
      }
      this.searchParams.facetValueNames = facetVals
    }

    this.searchParams.keyword = this.routeQuery.keyword || ''
    this.selectedPage = parseInt(this.routeQuery.page as string) || 1
    this.searchParams.offset = (this.selectedPage - 1) * this.searchParams.limit
    this.fetchData(false)
    if (!this.isSearchView) {
      this.fetchCMSData()
    }
    this.handleAnalyticTracking()
  },
  mounted() {
    if (!this.isMobileView) {
      let affixTarget = document.getElementsByClassName('srh-Filter_Items')[0] as HTMLElement

      if (affixTarget) {
        let initialAffixPos = 10
        let currentPos = window.pageYOffset
        let windowHeight = window.innerHeight

        affixTarget.style.top = `${initialAffixPos}px`

        document.addEventListener('scroll', () => {
          let affixHeight = affixTarget.offsetHeight
          let affixTop = parseInt(affixTarget.style.top, 10)
          let scrollY = window.pageYOffset

          let affixEndPos = windowHeight - affixHeight // update end position

          if (affixHeight > windowHeight) {
            if (window.pageYOffset < currentPos) { // on scrolling up
              if (affixTop < initialAffixPos) {
                affixTarget.style.top = `${affixTop + currentPos - scrollY}px`
              } else if (affixTop > initialAffixPos) { // reached top of sidebar
                affixTarget.style.top = `${initialAffixPos}px`
              }
            } else {
              if (affixTop > affixEndPos) { // on scrolling down
                affixTarget.style.top = `${affixTop + currentPos - scrollY}px`
              } else if (affixTop < affixEndPos) { // reached bottom of sidebar
                affixTarget.style.top = `${affixEndPos - 10}px`
              }
            }
          }
          currentPos = scrollY // update current position
        })
      }
    } else {
      let sortFilterEl = document.getElementsByClassName('srh-FilterSort')[0] as HTMLElement
      let lastScrollY = 0
      if (sortFilterEl) {
        document.addEventListener('scroll', () => {
          let scrollY = window.pageYOffset
          if (scrollY < lastScrollY) {
            sortFilterEl.classList.add('sticky')
          } else {
            sortFilterEl.classList.remove('sticky')
          }
          lastScrollY = scrollY
        })
      }
    }
  },
  methods: {
    buildBreadcrumb(childCategoryName: string, fromPage: string) {
      // breadcrumb rule:
      // top page -> brand -> brand • child category
      const parentCategory = this.productCategories.find(
        category => category.childCategories.some(child => child.name === childCategoryName)
      )
      const childCategoryDisplayName = parentCategory ? parentCategory.childCategories.find(
        child => child.name === childCategoryName
      )?.displayName : ''
      if (!parentCategory || !childCategoryDisplayName) return
      let breadcrumbList: {
        name: string
        url: string | null
      }[] = []
      if (fromPage === ROUTE_NAMES.BRAND) {
        const brand = initPageBrand
        if (!brand) return
        breadcrumbList = [
          {
            name: 'トップページ',
            url: '/'
          },
          {
            name: brand.displayName,
            url: `/brands/${brand.brandName}`
          },
          {
            name: `${brand.displayName}の${childCategoryDisplayName}`,
            url: null
          }
        ]
      }

      if (fromPage === ROUTE_NAMES.CHILD_CATEGORY) {
        breadcrumbList = [
          {
            name: 'トップページ',
            url: '/'
          },
          {
            name: childCategoryDisplayName,
            url: null
          }
        ]
      }

      if (breadcrumbList.length) {
        const htmlStr = breadcrumbList.reduce((acc, item, index) => {
          if (item.url) {
            return acc +  `
              <li class="breadcrumb-list" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                <a class="breadcrumb-link" itemprop="item" href="${item.url}">
                  <span itemprop="name">${item.name}</span>
                  <meta content="${index + 1}" itemprop="position">
                </a>
              </li>
            `
          } else {
            return acc + `
              <li class="breadcrumb-list" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                <span itemprop="name">${item.name}</span>
                <meta content="${index + 1}" itemprop="position">
              </li>
            `
          }
        }, '')
        this.breadcrumbElm.innerHTML = htmlStr
      }
    },
    handleAnalyticTracking() {
      this.addEventListener()

      if (this.searchParams.keyword && this.routeQuery[SEARCH_TRACKING_QUERY]) {
        this.shouldTrackingSearchKeyword = true
      }
      const referrerUrl = document.referrer
      if (/\/\/apparel.*\/products\/.*/.test(referrerUrl) && !this.routeQuery[SEARCH_TRACKING_QUERY]) {
        let trackingData = {}
        const data = JSON.stringify(this.routeQuery)

        trackingData = {
          tagData: data
        }
        this.trackingProductSearchTagReferrer(trackingData)
      }
    },
    trackingSearchKeyword() {
      if (this.shouldTrackingSearchKeyword) {
        this.shouldTrackingSearchKeyword = false
        raksulBQEventTracker({
          eventName: BQ_EVENT_NAMES.SEARCH_KEYWORD,
          data: {
            keyword: this.searchParams.keyword,
            count: this.itemTotalCount
          }
        })
        const updatedRoute = omit(this.routeQuery, SEARCH_TRACKING_QUERY)
        this.$router.replace({
          query: updatedRoute
        })
      }
    },
    trackingProductSearchTagReferrer(data: {[key: string]: string}) {
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.PRODUCT_SEARCH_TAG_CLICK,
        data
      })
      gaEventTracker(EVENT_CATEGORIES.PRODUCT_DETAIL, EVENT_ACTIONS.CLICK, EVENT_LABELS.PRODUCT_SEARCH_TAG_CLICK)
    },
    toggleSectionHandler(value: { toggle: boolean; id: string }) {
      this.$store.commit(value.id, value.toggle)
    },
    toggleFilterBrandHandler(value: boolean) {
      this.$store.commit(MutationTypes.SET_OPEN_BRAND_FILTER, value)
    },
    facetCanonicalType(data: string[]): {
      [key: string]: { [key: string]: string } | string[]
    } {
      const arrayKeyIndividual: { [key: string]: string } = {}
      const arrayKeyAggregate: string[] = []
      this.allSearchFacets.forEach((item1: SearchFacets) => {
        if (item1.canonicalSetting == FACET_INDIVIDUAL) {
          const arrayValues: string[] = []
          item1.facetValues.forEach((item2: SearchFacetValues) => {
            if (data.includes(item2.facetValueName)) {
              arrayValues.push(item2.facetValueName)
            }
            arrayKeyIndividual[item1.facetKeyName] = arrayValues?.toString()
          })
        } else {
          arrayKeyAggregate.push(item1.facetKeyName)
        }
      })
      return {
        individualType: arrayKeyIndividual,
        aggregateType: arrayKeyAggregate
      }
    },
    initCategoryId(): string {
      return this.viewMode === VIEW_MODES.SEARCH_CATEGORIES
        ? this.pageCategoryId || initPageCategoryId
        : this.routeQuery?.category || ''
    },
    initIndustryIds(): string {
      const id = this.pageIndustryId || initPageIndustryId
      return (this.viewMode === VIEW_MODES.SEARCH_INDUSTRIES && id)
        ? id.toString()
        : this.routeQuery?.industries || ''
    },
    quantityUnitPriceHandler() {
      const filterUnitPrice = this.$refs.filterUnitPrice as HTMLElement
      const minRange = Number(filterUnitPrice?.minRange)
      this.searchParams.minUnitPrice = minRange && !isNaN(minRange) ? minRange : undefined

      const maxRange = Number(filterUnitPrice?.maxRange)
      this.searchParams.maxUnitPrice = maxRange && !isNaN(maxRange) ? maxRange : undefined

      this.fetchDataFilterHandler()
    },
    resetAllFiltersHandler() {
      this.searchParams.categoryId = null
      this.searchParams.industryIds = []
      this.searchParams.minUnitPrice = this.minThreshold
      this.searchParams.maxUnitPrice = this.maxThreshold
      this.searchParams.printingMethods = []
      this.searchParams.facetValueNames = []
      this.searchParams.editPatterns = []
      this.searchParams.offset = 0
      this.categoryLabel = ''
      this.fetchDataFilterHandler()
    },
    resetIndustry(value: number) {
      this.searchParams.industryIds =  this.searchParams.industryIds.filter(i => i !== value)
      this.fetchDataFilterHandler()
    },
    resetUnitPrice() {
      this.searchParams.minUnitPrice = this.minThreshold
      this.searchParams.maxUnitPrice = this.maxThreshold
      this.fetchDataFilterHandler()
    },
    resetPrintMethod(value: string) {
      const methodItems = this.searchParams.printingMethods
      this.searchParams.printingMethods = methodItems.filter(i => i !== value)
      this.fetchDataFilterHandler()
    },
    onRemoveEditPatternFilterHandler(value: string) {
      this.searchParams.editPatterns = this.searchParams.editPatterns?.filter(item => item !== value)
      this.fetchDataFilterHandler()
    },
    resetFacetHandler(value: string) {
      this.searchParams.facetValueNames.splice(
        this.searchParams.facetValueNames.indexOf(value),
        1
      )
      this.fetchDataFilterHandler()
    },
    removeDesignImage() {
      this.searchParams.userDesignVersionUuid = undefined
      this.fetchDataFilterHandler()
    },
    onSelectPageIndex(pageIndex: number) {
      if (this.selectedPage != pageIndex) {
        this.selectedPage = pageIndex
        this.searchParams.offset =
          (this.selectedPage - 1) * this.searchParams.limit
        this.updateRouteQuery()
        this.fetchData()
      }
    },
    sortOrderHandler(value: string) {
      this.searchParams.sortOrder = value
      this.fetchDataFilterHandler()
    },
    categoryHandler(value: string) {
      this.searchParams.categoryId = value ?? null
      this.fetchDataFilterHandler()
    },
    industriesHandler(payload: { ids: number[]; name: string }) {
      this.searchParams.industryIds = payload.ids
      this.fetchDataFilterHandler()
    },
    printMethodHandler(data: string[]) {
      this.searchParams.printingMethods = data
      this.fetchDataFilterHandler()
    },
    searchEditPatternHandler(value: string[]) {
      this.searchParams.editPatterns = value
      this.fetchDataFilterHandler()
    },
    searchFacetHandler(values: any) {
      this.searchParams.facetValueNames = values
      this.fetchDataFilterHandler()
    },
    activeParamModal() {
      this.paramModalVisible = true
    },
    closeParamModal() {
      this.paramModalVisible = false
    },
    mergeSearchParams(values: SearchParamModel) {
      this.searchParams = cloneDeep(values)
      this.fetchDataFilterHandler()
      this.paramModalVisible = false
    },
    searchPayloadHandler(): {
      [key: string]: string | string[] | number | null | Array<FacetValuesType>
    } {
      return {
        categoryId: this.searchParams.categoryId,
        minUnitPrice: this.searchParams.minUnitPrice,
        maxUnitPrice: this.searchParams.maxUnitPrice,
        printingMethods: this.searchParams.printingMethods,
        facets: this.initFacetKeyCondition || this.formatFacets
      }
    },
    sortFacetKey(facetKeyArray: SearchFacets[]) {
      facetKeyArray.forEach(
        item => item.facetValues = orderBy(
          item.facetValues,
          'facetValueDisplayOrder',
          'asc'
        )
      )
      return orderBy(facetKeyArray, 'facetKeyDisplayOrder', 'asc')
    },
    async fetchData(updateQuery = true) {
      this.loadingState = true
      this.updateFacetMenuPos()
      const searchPayload = this.searchPayloadHandler()
      this.initFacetKeyCondition = null
      const res = await getAllSearchProducts(
        searchPayload.categoryId!,
        this.searchParams.industryIds,
        searchPayload.minUnitPrice,
        searchPayload.maxUnitPrice,
        searchPayload.printingMethods,
        searchPayload.facets,
        this.searchParams.offset,
        this.searchParams.limit,
        this.searchParams.sortOrder,
        this.searchParams.keyword,
        this.searchParams.userDesignVersionUuid,
        this.searchParams.editPatterns
      ).catch(error => {
        this.itemTotalCount = 0
        updateQuery && this.updateRouteQuery()
        const errorData = `${error?.message}---${JSON.stringify(this.searchParams)}`
        throw new Error(errorData)
      }).finally(() => {
        this.isLoadingDone = true
        this.loadingState = false
      })
      if (res?.data) {
        const { data } = res
        this.productCards = data?.productSearch?.items
        this.itemTotalCount = data?.productSearch?.totalItemsCount
        this.printingMethodsCount = data?.productSearch?.printingMethod
        this.allSearchFacets = this.sortFacetKey(data?.productSearch?.facets)
        this.categorySearchCount = data?.productSearch?.categories
        this.designImage = data?.productSearch?.designImage
        this.editPatternList = [...data.productSearch.editPatterns]
        this.sortProductCategories()
        this.trackingSearchKeyword()
      }

      updateQuery && this.updateRouteQuery()
    },
    async fetchCMSData() {
      const cmsData = await getCMSLinks(this.cmsMappableType, this.cmsMappableIds)
      if (cmsData) {
        this.cmsLinks = cmsData?.cmsMapping?.cmsCategories.map(item => ({
          name: item.h1,
          url: item.url
        }))
        this.cmsMagazines = cmsData?.cmsMapping?.cmsMagazines
      }
    },
    fetchDataFilterHandler() {
      this.selectedPage = 1
      this.searchParams.offset = 0
      if (this.$route.name !== ROUTE_NAMES.SEARCH) {
        const query = this.buildRouteQuery()
        this.$router.push({
          name: ROUTE_NAMES.SEARCH,
          query: query
        })
      } else {
        this.fetchData()
      }
    },
    updateRouteQuery() {
      const formatQuery = { ...this.buildRouteQuery() }
      this.$router.push({ query: formatQuery })
    },
    buildRouteQuery() {
      const facetParams = Object.keys(this.setFacetUrl).reduce(
        (obj: { [key: string]: string }, key: string) => {
          obj[FACET_QUERY_PREFIX + key] = this.setFacetUrl[key]
          return obj
        },
        {}
      )
      const coreQuery = getSearchPageQueryObject({
        categoryId: this.searchParams.categoryId as string,
        page: this.selectedPage,
        sortOrder: this.searchParams.sortOrder,
        industryIds: this.searchParams.industryIds
      })
      let query = {
        ...coreQuery,
        max: this.searchParams.maxUnitPrice?.toString(),
        min: this.searchParams.minUnitPrice?.toString(),
        printing: this.searchParams.printingMethods.join(','),
        keyword: this.searchParams.keyword,
        designVersion: this.searchParams.userDesignVersionUuid,
        editPatterns: this.searchParams.editPatterns?.join(','),
        ...facetParams
      }
      return omitBy(query, isEmpty)
    },
    getValueByKeys(
      category: ProductCategory,
      key: string,
      output: { [key: string]: string | number }
    ) {
      const childCategory =
        category.childCategories ?? category.childCategories
      output[category.id] = category[key]
      if (childCategory) {
        childCategory.forEach(item => this.getValueByKeys(item, key, output))
      }
    },
    getSortInitValue(queryValue?: string) {
      const sortItem = SORT_ORDER.find(item => item.value === queryValue)
      return sortItem ? queryValue : DEFAULT_SORT_ORDER
    },
    addEventListener() {
      eventBus.$on(APP_EVENTS.SEARCH_KEYWORD_APPLY, (keyword: string) => {
        this.searchParams.keyword = keyword
        this.shouldTrackingSearchKeyword = true
        this.resetAllFiltersHandler()
      })
    },
    sortProductCategories() {
      const sortCategories = (category: ProductCategory) => {
        if (category.childCategories?.length === 0) return
        category.childCategories.sort((elm1, elm2) => {
          return this.setCategoryCount[elm2.id] - this.setCategoryCount[elm1.id]
        })
        category.childCategories.forEach(item => sortCategories(item))
      }
      this.sortedProductCategories.forEach(parentCategory => {
        sortCategories(parentCategory)
      })
    },
    updateFacetMenuPos() {
      if (!this.isMobileView) {
        let affixTarget = document.getElementsByClassName('srh-Filter_Items')[0] as HTMLElement
        if (affixTarget) {
          affixTarget.style.top = '10px'
        }
      }
    }
  }
})
